import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  getDemurrage,
  addDemurrage,
  getTrukerNameList,
  getDefoultPickuLocation,
  getAttachmentsOnly,
//  getCheckList,
  getDemurrageView,
  fetchCFSNameByCountry,
  fetchEmptyYardNameByCountry,
  getDeliveryOrderDataForExtension,
  getPaymentReceiptsForDO,
} from "../../../dashboard/actions/instruction";
import { verify } from "crypto";
import { boolean, string } from "yup";
import { getReleaseAttConf } from "../actions/Instruction";

interface IDemurrageForm {
  senderEmail: string | null;
  intendedDate: string | null;
  truckerCode: string | null;
  country: string | null;
  status: string | null;
  requestedPartnerName: string | null;
}

interface IDemurrageContainerDetails {
  //vesselType: any;
  containerNo: string | null;
  IntendedDate: string | null;
  truckerCode: string | null;
  pickupLocation: string | null;
  truckerName: string | null;
  truckerId: string | null;
  internalCode: string | null;
}

interface IDemurrageDocAttachmentDetails {
  //vesselType: any;
  docId: string | null;
  fileName: any | null;
  byteArray: string | null;
}

interface IDemurrageList {
  list: any[];
  next: string | null;
  previous: string | null;
}

interface IDemurrageDocAttachmentList {
  list: any[];
  next: string | null;
  previous: string | null;
}

export interface IDemurrageDetails {
  selectedTruckerCode: any;
  data: IDemurrageList;
  attData: IDemurrageDocAttachmentList;
  extensionAttData: IDemurrageDocAttachmentList; // extension request files
  isDemurrageDetailsLoading: boolean;
  dataLoading: boolean;
  demurrageForm: IDemurrageForm;
  selectedDate: any;
  docList: any[] | null;
  version: number | null;
  extensionDocList: any[] | null; // attachment configs for extension request
  dropdownDocList: any[] | null;  //  attachment configs for hidden documents
  pickUpLocation: any[];
  truckerList: any[];
  selectedAttachmentName: any;
  selectedAttachmentBytrr: any;
  selectedAttachmentFilePath: any;
  selectedDocId: any;
  selectedPickupLocation: any;
  selectedCfsName:any;
  selectedCfsName216:any;
  doExtensionRequestAllowed:boolean;
  cfsList:any[];
  emptyYardList:any[];
  selectedemptyYardName:any;
  selectedTruckerName: any;
  selectedtruckerId: any;
  selectedinternalCode: any;
  selectedDefaultPickupLocation: any;
  selectedFileServerPath: any;
  checkList:any;
  linerDocs: Array<any>;
  receiptDocList: any[];
  receiptDocListLoading: boolean;
  
  
}

const initialState: IDemurrageDetails = {
  data: {
    list: [],
    next: null,
    previous: null,
  },
  cfsList:[],
  emptyYardList:[],
  attData: {
    list: [],
    next: null,
    previous: null,
  },
  extensionAttData: {
    list: [],
    next: null,
    previous: null,
  },
  docList: null,
  extensionDocList: null,
  dropdownDocList: null,
  pickUpLocation: [],
  checkList:[],

  dataLoading: true,
  isDemurrageDetailsLoading: false,
    doExtensionRequestAllowed:false,
  demurrageForm: {
    senderEmail: "",
    intendedDate: "",
    truckerCode: "",
    country: "",
    status: "",
    requestedPartnerName: "",
  },
  selectedDate: {},
  selectedTruckerCode: {},
  selectedAttachmentName: {},
  selectedAttachmentBytrr: {},
  selectedDocId: {},
  selectedPickupLocation: {},
  selectedTruckerName: {},
  selectedtruckerId: {},
  truckerList: [],

  selectedinternalCode: {},
  selectedAttachmentFilePath: {},
  selectedDefaultPickupLocation: "",
  selectedFileServerPath :{},
  linerDocs: [],
  receiptDocList: [],
  receiptDocListLoading: false,
  selectedCfsName:{
    label:null,
    value:0
  },
  selectedCfsName216:{
    label:null,
    value:0
  },
  selectedemptyYardName:{
    label:null,
    value:null
  },
  version: null,
 
};

export const DemurrageSlice = createSlice({
  name: "demurrage",
  initialState,
  reducers: {
    updateDemurrageList: (state, action: PayloadAction<IDemurrageList>) => {
      state.data = action.payload;
    },
    clearPickupLocation:(state)=>{
      const formattedData={
        ...state.data,
        list:state.data.list.map((dt:any)=>(
        {
          ...dt,
          pickupLocation:null
        }
      ))}
      state.data=formattedData;
    },
     updateDoExtensionRequestAllowed: (state, action: any) => {
      state.doExtensionRequestAllowed = action.payload;
    },
    updateSelectedDateDV: (state, action: PayloadAction<any>) => {
      state.selectedDate = action.payload;
    },
    updateSelectedtruckerCode: (state, action: PayloadAction<any>) => {
      state.selectedTruckerCode = action.payload;
    },
    updateSelectedAttachmentName: (state, action: PayloadAction<any>) => {
      state.selectedAttachmentName = action.payload;
    },
    updateSelectedAttachmentBytrr: (state, action: PayloadAction<any>) => {
      state.selectedAttachmentBytrr = action.payload;
    },
    updateSelectedDocId: (state, action: PayloadAction<any>) => {
      state.selectedDocId = action.payload;
    },
    updateAdttamentData: (state, action: PayloadAction<any>) => {
      state.attData.list = action.payload;
    },
    updateTruckerList: (state, action: PayloadAction<any>) => {
      state.truckerList = action.payload;
    },
    updateSelectedPickupLocation: (state, action: PayloadAction<any>) => {
      state.selectedPickupLocation = action.payload;
    },
    updateSelectedTruckerName: (state, action: PayloadAction<any>) => {
      state.selectedTruckerName = action.payload;
    },
    updateSelectedtruckerId: (state, action: PayloadAction<any>) => {
      state.selectedtruckerId = action.payload;
    },
    updateselectedInternalCode: (state, action: PayloadAction<any>) => {
      state.selectedinternalCode = action.payload;
    },
    updatePickupLocation: (state, action: PayloadAction<any>) => {
      state.pickUpLocation = action.payload;
    },
    updateSelectedAttachmentFilePath: (state, action: PayloadAction<any>) => {
      state.selectedAttachmentFilePath = action.payload;
    },

    updateSelectedCheckList: (state, action: PayloadAction<any>) => {
      const row = state.checkList.find((item:any)=> item.docId==action.payload.docId)
      if(row){
        row.check=action.payload.check
     }
    },
    updateselectedCheckListRemark: (state, action: PayloadAction<any>) => {
      const row = state.checkList.find((item:any)=> item.docId==action.payload.docId)
      if(row){
        row.remarks=action.payload.remarks
     }
    },
   clearSelectedFileServerPath:(state)=>{state.selectedFileServerPath = {}},

    clearFields: (state) => { 
      // state.docList = null;
      state.dropdownDocList = null;
      state.selectedAttachmentName = {}; 
      state.selectedAttachmentFilePath = {};
      state.selectedFileServerPath = {};
    },
    clearReceiptDocList: (state) => {
      state.receiptDocList = [];
      state.receiptDocListLoading = false;
    },

    updateSelectedFileServerPath:(state, action:PayloadAction<any>)=>{
      state.selectedFileServerPath = action.payload
    },
    updateLinerVerify: (state, action: PayloadAction<any>) => {
      const row = state.attData.list.find((Item)=> Item.docId==action.payload.docId)
      if(row){
        row.isVerify=action.payload.verify
        row.fileName=action.payload.fileName
        row.actionBy=action.payload.actionBy
        row.actionOn=action.payload.actionOn
      }
     
     
    },
    // updateAttachmentList:(state, action)=>{
    //   state.docList = action.payload??[]
    //   state.attData.list = (action.payload??[]).map((x:any)=>({
    //     rowNumber:x.rowNumber,
    //     dndInstructionAttId: null,
    //     docId: x.id,
    //     fileName: "",
    //     verify:false,
    //     actionBy:"",
    //     actionOn:"",
    //     m: x.m,
    //     ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {})
    //     // isDropDownDoc: x?.isDropDownDoc
    //   }))
    // },
    // ----- here new actions added ---- 
    addDocument:(state, action)=>{
      const { isExtension } = action.payload;
      if (!state.dropdownDocList || state.dropdownDocList.length === 0) return;

      const docListKey = isExtension ? 'extensionDocList' : 'docList';
      const attDataKey = isExtension ? 'extensionAttData' : 'attData';
      // const docList = state[docListKey];
      // const attData = state[attDataKey];


      const rowNumber = crypto.randomUUID()
      const newDoc = { rowNumber:rowNumber, ...state.dropdownDocList[0]};

      state[docListKey] = [...(state[docListKey] ?? []), newDoc]

      state[attDataKey].list =[
        ...state[attDataKey].list,
        {
        rowNumber:newDoc.rowNumber,
        dndInstructionAttId: null,
        docId: newDoc.id,
        fileName: "",
        verify:false,
        actionBy:"",
        actionOn:"",
        m: newDoc.m,
        isDropDownDoc:true
      }
      ]
    },
    removeDocument:(state, action)=>{
      const { rowNumber, isExtension } = action.payload;
      const rowNumberToRemove = rowNumber;

      const docListKey = isExtension ? 'extensionDocList' : 'docList';
      const attDataKey = isExtension ? 'extensionAttData' : 'attData';

      state[docListKey] = (state[docListKey]??[]).filter(doc => doc.rowNumber !== rowNumberToRemove);

      state[attDataKey].list =(state[attDataKey].list ?? []).filter(att => att.rowNumber !== rowNumberToRemove);

      const { [rowNumberToRemove]: removedName, ...restSelectedAttachmentName } = state.selectedAttachmentName ?? {};
      state.selectedAttachmentName = Object.keys(restSelectedAttachmentName).length > 0 ?
        restSelectedAttachmentName : {};

      const { [rowNumberToRemove]: removedFilePath, ...restSelectedAttachmentFilePath } = state.selectedAttachmentFilePath ?? {};
      state.selectedAttachmentFilePath = Object.keys(restSelectedAttachmentFilePath).length > 0 ? restSelectedAttachmentFilePath : {};

      const { [rowNumberToRemove]: removedServerPath, ...restSelectedFileServerPath } = state.selectedFileServerPath ?? {};
      state.selectedFileServerPath = Object.keys(restSelectedFileServerPath).length > 0 ?
      restSelectedFileServerPath : {};

    },
    updateListByRowNumber: (state, action) => { // only for dropdown change
      const { rowNumber, updatedFields, isExtension } = action.payload;

      const docListKey = isExtension ? 'extensionDocList' : 'docList';
      const attDataKey = isExtension ? 'extensionAttData' : 'attData';

      const docList = state[docListKey];
      if (!docList) return;
      // Find the index of the doc to update
      const docListIndex = (docList ?? []).findIndex(doc => doc.rowNumber === rowNumber);

      if (docListIndex !== -1) {
        // docListIndex the found doc by merging the updated fields
        docList[docListIndex] = {
          ...docList[docListIndex],
          ...updatedFields
        };
      }

      if (state[attDataKey]?.list) {

        const attIndex = (state[attDataKey].list ?? []).findIndex(att => att.rowNumber === rowNumber);
        if (attIndex !== -1) {
          state[attDataKey].list[attIndex] = {
            ...state[attDataKey].list[attIndex],
            docId: updatedFields.id,
          };
        }
      }

    },
    updateDocumentMandatoryByDocId: (state, action: PayloadAction<any>) => {
      const { docId, mandatory, isExtension } = action.payload ?? {};
      const normalizedDocId = Number(docId);
      if (!normalizedDocId) return;

      const docListKey = isExtension ? 'extensionDocList' : 'docList';
      const attDataKey = isExtension ? 'extensionAttData' : 'attData';

      state[docListKey] = (state[docListKey] ?? []).map((doc: any) =>
        Number(doc?.id) === normalizedDocId ? { ...doc, m: mandatory } : doc
      );

      state[attDataKey].list = (state[attDataKey].list ?? []).map((doc: any) =>
        Number(doc?.docId) === normalizedDocId ? { ...doc, m: mandatory } : doc
      );
    },

    //---- new ends here ----

    updateSelectedCfsName:(state, action: PayloadAction<any>)=>{
      state.selectedCfsName = action.payload;
    },
    updateSelectedCfsName216:(state, action: PayloadAction<any>)=>{
      state.selectedCfsName216 = action.payload;
    },
    updateSelectedemptyYardName:(state, action: PayloadAction<any>)=>{
      state.selectedemptyYardName = action.payload;
    },
    setLinerAttachment: (state, action)=>{
      const row = state.linerDocs.find((i)=>i.docId == action.payload.docId)
      if(!row) return
      Object.entries(action.payload).forEach(([key, val])=>{
        if(Object.hasOwn(row, key))row[key] = val
      }) 
    }
  },
  extraReducers: (builder) => {
    builder.addCase(addDemurrage.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(fetchCFSNameByCountry.fulfilled,(state,action:any)=>{
        state.cfsList = action.payload
        if(state.selectedCfsName?.value) {
          state.selectedCfsName.label = action.payload
            .find((x:any)=>x.value == state.selectedCfsName.value)?.label ??null
        }
        if(state.selectedCfsName216?.value) {
          state.selectedCfsName216.label = action.payload
            .find((x:any)=>x.value == state.selectedCfsName216.value)?.label ??null
        }
    });
    builder.addCase(fetchEmptyYardNameByCountry.fulfilled,(state,action:any)=>{
      state.emptyYardList = action.payload
      if(!state.selectedemptyYardName?.value)return;

      state.selectedemptyYardName.label = action.payload
        .find((x:any)=>x.value == state.selectedemptyYardName.value)?.label ??null
  })
    builder.addCase(addDemurrage.fulfilled, (state, action) => {
      state.dataLoading = false;
    });

    builder.addCase(getDefoultPickuLocation.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(getDefoultPickuLocation.fulfilled, (state, action) => {
      state.selectedDefaultPickupLocation = action?.payload?.toString() || "";
      
    });

    /* builder.addCase(getCheckList.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(getCheckList.fulfilled, (state, action) => {
      state.checkList = action?.payload ??[];
    }); */

    builder.addCase(getDemurrage.pending, (state, action) => {
      state.data = {
        list: [],
        next: null,
        previous: null,
      };
      state.dataLoading = true;
    });
    builder.addCase(getDemurrage.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getDemurrageView.pending, (state,action)=>{
      state.selectedemptyYardName.label=null
      state.selectedemptyYardName.value=null
      state.selectedCfsName.value=null
      state.selectedCfsName.label=null
      state.selectedCfsName216.value=null
      state.selectedCfsName216.label=null
    })
    builder.addCase(getDemurrageView.fulfilled, (state,action)=>{

      state.dropdownDocList = action.payload.data?.dropdownDocList??[]

      state.extensionDocList = action.payload.data?.updatedDocListData??[]
      state.extensionAttData.list = action?.payload?.data?.attList || [];

      state.docList = action.payload.data?.updatedDocListData??[]
      state.attData.list= action?.payload?.data?.attList || [];
      state.version= action?.payload?.data?.version || null;
      state.checkList = action.payload.data?.checkList;
      state.linerDocs = (action.payload.data?.linerDocs??[]).map((x:any)=>({
        doReleasePdfId: x.doReleasePdfId,
        id: x.demurrageInstructionLinerAttId,
        name: x.docDesc,
        loading:0,
        docId: x.docId,
        fileName: x.fileName??'',
        filePath: x.filePath??'',
        m: x.isMandatory=='Y',
        isRejected: x.isMandatory=='R',
        serverPath: null,
        tempName: null
      }))
      const pid = action.payload.data.list.find((x: any) => x.cfsPartnerId)?.cfsPartnerId
      const lbl = state.cfsList.find((x: any) => x.value == pid)?.label
      const hasLinerAtt = (docId: any) =>
        state.linerDocs.some(
          (x: any) =>
            x.docId == docId &&
            !!(x.fileName || x.filePath || x.id),
        )
      if (pid && hasLinerAtt(206)) {
        state.selectedCfsName.value = pid
        state.selectedCfsName.label = lbl
      } 
      // else {
      //   state.selectedCfsName.value = null
      //   state.selectedCfsName.label = null
      // }
      if (pid && hasLinerAtt(216)) {
        state.selectedCfsName216.value = pid
        state.selectedCfsName216.label = lbl
      } 
      // else {
      //   state.selectedCfsName216.value = null
      //   state.selectedCfsName216.label = null
      // }
      state.selectedemptyYardName.value = action.payload.data.list.find((x:any)=>x.emptyYardPartnerId)?.emptyYardPartnerId
      state.selectedemptyYardName.label = state.emptyYardList.find((x)=>x.value==state.selectedemptyYardName.value)?.label
    })
    // builder.addCase(getDeliveryOrderDataForExtension.pending, (state, action) => {

    // })
    builder.addCase(getDeliveryOrderDataForExtension.fulfilled, (state, action) => {

      const deliveryOrder = (action?.payload?.dndInstructionAtt ?? []).find((doc: any) => doc.docId === 206);

      const existingDoc = (state.extensionAttData.list ?? []).find((doc: any) => doc.isDOExtensionFile);
      existingDoc.fileName = deliveryOrder.fileName
      existingDoc.filePath = deliveryOrder.filePath

      state.selectedFileServerPath = {
        ...state.selectedFileServerPath,
        [existingDoc.rowNumber]: [existingDoc.filePath, existingDoc.fileName],
      }

      state.selectedAttachmentName = {
        ...state.selectedAttachmentName,
        [existingDoc.rowNumber]: { name: existingDoc.fileName },
      };

      state.selectedAttachmentFilePath = {
        ...state.selectedAttachmentFilePath,
        [existingDoc.rowNumber]: null,
      };

      const dropdownDocId = state.dropdownDocList?.map((i: any) => i.id);


      // const dropdownDocs = action?.payload?.dndInstructionAtt
      //   .filter((i: any) => dropdownDocId?.includes(i.docId))
      //   .map((e: any) => ({
      //     rowNumber: existingDoc.rowNumber,
      //     id: e?.docId,
      //     name: state.dropdownDocList?.find((i: any) => i?.id === e?.docId)?.name,
      //     m: true,
      //     isDropDownDoc: true
      //   }));

      // state.extensionDocList = [...(state.extensionDocList ?? []), , ...dropdownDocs]

      state.extensionAttData.list = (state.extensionDocList ?? [])?.map((x: any) => ({
        rowNumber: x.rowNumber,
        dndInstructionAttId: null,
        docId: x.id,
        fileName: "",
        verify: false,
        actionBy: "",
        actionOn: "",
        m: x.m,
        ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {}),
        ...(x.hasOwnProperty('isDOExtensionFile') ? { isDOExtensionFile: x.isDOExtensionFile } : {})

        // isDropDownDoc: x?.isDropDownDoc
      }))

      action?.payload?.data?.extensionAttList?.forEach((data: any) => {
        const key = data?.dndInstructionAttId ?? data?.rowNumber ?? null;
        state.selectedAttachmentFilePath[key] = data.filePath
        state.selectedAttachmentName[key] = { name: data.fileName }
      })

    })
    builder.addCase(getPaymentReceiptsForDO.pending, (state) => {
      state.receiptDocListLoading = true;
      state.receiptDocList = [];
    });
    builder.addCase(getPaymentReceiptsForDO.fulfilled, (state, action) => {
      state.receiptDocListLoading = false;
      const list = action.payload ?? [];
      state.receiptDocList = (list ?? []).slice(0, 10).map((item: any) => ({
        rowNumber: item.rowNumber ?? crypto.randomUUID(),
        receiptId: item.receiptId ?? null,
        receiptNo: item.receiptNo ?? '',
      }));
    });
    builder.addCase(getPaymentReceiptsForDO.rejected, (state) => {
      state.receiptDocListLoading = false;
      state.receiptDocList = [];
    });
    builder.addCase(getAttachmentsOnly.fulfilled,(state, action)=>{
      // resetting attData.list to initial value
      // state.attData.list = state.docList?.map((x:any)=>({
      //   rowNumber:x?.rowNumber,
      //   dndInstructionAttId: null,
      //   docId: x.id,
      //   fileName: "",
      //   actionBy:"",
      //   m: x.m,
      // }))??[]
      state.dropdownDocList = action.payload?.dropdownDocList??[]

      if(!action.payload?.att)return
      state.docList = action.payload?.updatedDocListData??[]
      state.attData.list = action.payload?.att || []
      state.extensionDocList = action.payload?.updatedDocListData??[]
      state.extensionAttData.list = action.payload?.att || [];
      state.version=action.payload.version;
      if(action.payload?.chk) state.checkList = action.payload.chk

      action.payload?.att?.forEach((data:any)=>{
        // const row = state.attData.list.find((item)=>item.docId == data.docId)
        // if(!row)return
        // row.fileName = data.fileName
        // row.dndInstructionAttId = data.dndInstructionAttId
        // row.filePath = data.filePath
        // row.actionBy = data?.actionBy
        // row.isVerify = data?.isVerify=="Y"
        const key = data?.dndInstructionAttId ?? data?.rowNumber ?? null;
        state.selectedAttachmentFilePath[key] = data.filePath
        state.selectedAttachmentName[key] = {name: data.fileName}
      })

    });
    builder.addCase(getReleaseAttConf.fulfilled,(state, action)=>{

      const updatedDocList = action?.payload?.data?.filter((i: any) => (i.isMandatory != "H" && i.isMandatory != "E"))?.map?.((i: any) => ({
        rowNumber: crypto.randomUUID(),
        id: i?.docId,
        name: i.docName,
        m: i.isMandatory == 'Y',
        // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
      }))

      const updatedExtensionDocList = action?.payload?.data?.filter((i: any) => (i.isMandatory == "E"))?.map?.((i: any) => ({
        rowNumber: crypto.randomUUID(),
        id: i?.docId,
        name: i.docName,
        m: (action?.payload?.country == 'ZA' && action?.payload?.linerId == '24118' && i?.docId == 309)? false: true,
        isDOExtensionFile: true
        // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
      }))

      const dropdownOptions = action?.payload?.data?.filter((i: any) => (i.isMandatory == "H"))?.map?.((i: any) => ({
        id: i?.docId,
        name: i.docName,
        m: true,
        isDropDownDoc: true
      }))

      state.dropdownDocList = dropdownOptions??[]

      state.docList = updatedDocList??[]
      state.extensionDocList = updatedExtensionDocList??[]

      state.attData.list = (updatedDocList??[])?.map((x:any)=>({
        rowNumber:x.rowNumber,
        dndInstructionAttId: null,
        docId: x.id,
        fileName: "",
        verify:false,
        actionBy:"",
        actionOn:"",
        m: x.m,
        ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {})
        // isDropDownDoc: x?.isDropDownDoc
      }))

      state.extensionAttData.list = (updatedExtensionDocList??[])?.map((x:any)=>({
        rowNumber:x.rowNumber,
        dndInstructionAttId: null,
        docId: x.id,
        fileName: "",
        verify:false,
        actionBy:"",
        actionOn:"",
        m: x.m,
        ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {}),
        ...(x.hasOwnProperty('isDOExtensionFile') ? { isDOExtensionFile: x.isDOExtensionFile } : {})
        // isDropDownDoc: x?.isDropDownDoc
      }))



    });
  },
});
export const {
  updateDemurrageList,
  updateSelectedDateDV,
  updateSelectedtruckerCode,
  updateSelectedAttachmentBytrr,
  updateSelectedAttachmentName,
  updateSelectedDocId,
  updateAdttamentData,
  updateSelectedPickupLocation,
  updateSelectedTruckerName,
  updateSelectedtruckerId,
  updateDoExtensionRequestAllowed,
  updateselectedInternalCode,
  updatePickupLocation,
  updateSelectedAttachmentFilePath,
  updateSelectedFileServerPath,
  clearSelectedFileServerPath,
  //
  addDocument,
  removeDocument,
  clearFields,
  clearReceiptDocList,
  //
  updateListByRowNumber,
  updateLinerVerify,
  updateSelectedCheckList,
  updateselectedCheckListRemark,
  setLinerAttachment,
  updateSelectedCfsName,
  updateSelectedCfsName216,
  updateSelectedemptyYardName,
  clearPickupLocation,
  updateDocumentMandatoryByDocId
} = DemurrageSlice.actions;

export default DemurrageSlice.reducer;
